import React from "react";

export default function Full(props) {
  return (
    <div style={{backgroundColor: "white", height: "100%"}}>
      {props.children}
    </div>
  );
}
